import { BaseAccountStore, LoginResp } from '@quan/mobx-logic';
import { persist } from '@quan/mobx-persist';
import { AccountlogicServices, QuanServices } from '@quan/proto-api-client';
import { delCookie } from '@planjs/utils';
import { action, observable } from 'mobx';
import { HEADER_AUTHORIZATION_KEY } from '@quan/services';

class UserStore extends BaseAccountStore<quan.LoginWechatByCodeReq, quan.LoginWechatByCodeRsp> {
  AccountlogicServices = AccountlogicServices;

  @persist @observable union_id = '';

  @observable wx_info: { uid?: string; name?: string } = {};

  @observable hasWatermark: boolean = false;

  @action setUnionId(union_id: string) {
    this.union_id = union_id;
  }

  async getWatermark() {
    const { watermark_setting } = await QuanServices.GetWatermarkSetting(
      {},
      { headers: { [HEADER_AUTHORIZATION_KEY]: this.sid } },
    );
    this.hasWatermark = watermark_setting?.is_enable ?? true;
  }

  // TODO app login
  async processDoLogin(req: quan.LoginWechatByCodeReq): Promise<LoginResp> {
    const { sid, sid_expired_at, wx_uid, wx_name, is_snapshotuser, union_id } =
      await QuanServices.LoginWechatByCode(req, {
        waitLock: false,
      });

    this.wx_info = { uid: wx_uid ?? '', name: wx_name ?? '' };

    this.setUnionId(union_id ?? '');

    delCookie('sid');
    return {
      sid: sid!,
      expired_at: sid_expired_at!,
      is_snapshotuser,
    };
  }

  processDoLoginOut(): void {
    console.log('login out');
    this.setUnionId('');
  }
}

const userStore = new UserStore();

export default userStore;

export { UserStore };
